/*
 * 企業側 ホットライン 一覧取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_CLIENT_HOTLINE = 'API_GET_LIST_CLIENT_HOTLINE';
/**
 * ファイル共有 一括送付用の閲覧申請一覧取得
 */
export const apiGetListClientHotline = (_, meta) => apiGetList(API_GET_LIST_CLIENT_HOTLINE, '/client/hotline_list', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
